import renderInputField from 'components/FormControls/textInput'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Field, Form, formValueSelector, reduxForm } from 'redux-form'
import shouldAsyncValidate from 'utils/shouldAsyncValidate'
import baseLoginValidator from 'utils/validators/baseLoginValidator'
import emailValidator from 'utils/validators/emailValidator'
import * as Yup from 'yup'
import LoginField from '../subcomponents/LoginField'
import { useAccountCreateFormSubmit } from 'modules/Forms/Account/Create/useAccountCreateFormSubmit'
import SubmitButtons from 'modules/Forms/Account/Create/subcomponents/SubmitButtons'
import clsx from 'clsx'
import formStyles from 'modules/Forms/common-form.module.scss'
import { isRequiredField } from 'utils/isRequiredField'

export const PetalAdsSchema = () =>
  Yup.object().shape({
    logins: Yup.array().of(Yup.object()),
    login: Yup.string().when('logins', ([logins], schema) =>
      logins
        ? schema.strip()
        : schema
            .test('baseLoginTest', '', baseLoginValidator)
            .required('common::validation_messages.required'),
    ),
    network: Yup.string().required('common::validation_messages.required'),
    email: Yup.string()
      .test('emailValidator', 'common::validation_messages.incorrect_email_format', emailValidator)
      .required('common::validation_messages.required'),
  })

let CreatePetalAdsAccountForm = ({
  handleSubmit,
  submitting,
  onClose,
  autofill,
  formHeader,
  networkId,
  form,
  initialValues,
  array,
  multiLogins,
  networkType,
}) => {
  const selector = formValueSelector(form)
  const { t } = useTranslation()
  const submitAccountData = useAccountCreateFormSubmit({ form, onClose, multiLogins, networkType })

  const { email, user } = useSelector((state) => ({
    email: selector(state, 'email'),
    user: state['app'].user,
  }))

  useEffect(() => {
    user.name && email === initialValues.email && autofill('email', user.name)
  }, [user])

  return (
    <>
      {formHeader}

      <Form
        onSubmit={handleSubmit(submitAccountData)}
        noValidate
      >
        <Field
          disabled
          name="network"
          hidden
          fullWidth
          component={renderInputField}
          t={t}
        />

        <div className={clsx('margin-bottom-16', formStyles['row_with-tooltip'])}>
          <LoginField
            form={form}
            multiLogins={multiLogins}
            array={array}
            autofill={autofill}
            networkId={networkId}
            label={'services::forms.register_account.petal-ads.fields.login.label'}
          />
        </div>

        <div className={clsx('margin-bottom-16', formStyles['row_with-tooltip'])}>
          <Field
            name="email"
            required={isRequiredField(PetalAdsSchema(networkType), 'email')}
            type="email"
            fullWidth
            component={renderInputField}
            label={t('services::forms.register_account.petal-ads.fields.email.label')}
            t={t}
          />
        </div>

        <SubmitButtons
          formName={form}
          submitting={submitting}
          onClose={onClose}
        />
      </Form>
    </>
  )
}

CreatePetalAdsAccountForm = reduxForm({
  form: 'CreatePetalAdsAccountForm',
  initialValues: {
    network: '',
    login: '',
    email: '',
  },
  shouldAsyncValidate: shouldAsyncValidate,
})(CreatePetalAdsAccountForm)

CreatePetalAdsAccountForm.propTypes = {
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  onClose: PropTypes.func,
  autofill: PropTypes.func,
  networkId: PropTypes.string,
  initialValues: PropTypes.object,
  form: PropTypes.string,
  multiLogins: PropTypes.bool,
  array: PropTypes.object,
  formHeader: PropTypes.node,
  networkType: PropTypes.string,
}

export default CreatePetalAdsAccountForm
